<template>
  <v-col>
    <v-sheet class="align-center pa-2" :elevation="elevation">
      <span class="text-caption text--secondary stat-caption">{{ label }}</span>
      <span class="font-weight-bold stat-value">{{ value }}</span>
    </v-sheet>
  </v-col>
</template>

<script>
export default {
  props: ['label', 'value', 'color', 'elevation'],
  computed: {
    colorClass() {
      return this.color ? `text-${this.color}` : '';
    }
  }
};
</script>
<style scoped>
.stat-caption {
  display: block;
  font-size: 9px;
}
.stat-value {
  display: block;
  text-align: center;
  font-size: 20px;
}
</style>
